import { getSelectedCalendarsStore } from "../store/store";
import { dedupeObservableMapValues, flattenObservableMapValues, } from "owa-selected-calendars-utils";

export function getSelectedCalendars(): Map<string, string[]> {
    return dedupeObservableMapValues(getSelectedCalendarsStore().selectedCalendars);
}
export function getSelectedCalendarsFlatList(): string[] {
    return flattenObservableMapValues(getSelectedCalendars());
}
